var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arrowDown_svg__a",
    d: "M0 0h14v14H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "arrowDown_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrowDown_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#0FB269",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    mask: "url(#arrowDown_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.705 2.625.1 8.17M2.625 6.715l4.09 4.08 4.08-4.08"
  })))));
};
export default SvgArrowDown;